import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import messages from '../../../messages';
import Section from '../../../../components/Section';
import ControlContainer from '../../../../components/ControlContainer';
import P from '../../../../../../components/P';
import DuesProtectPermissions from '../../DuesProtectPermissions';
import DuesProtectPrivacyStatements from '../../DuesProtectPrivacyStatements';
import DuesProtectHipaaNotice from '../../DuesProtectHipaaNotice';
import CheckboxInput from './CheckboxInput';

const DuesProtectSection = ({
  signature,
  isReadOnly,
  handleChange,
  intl,
}) => (
  <Section>
    <ControlContainer>
      <P>
        <FormattedMessage {...messages.youAreAboutToSubmitYourClaimAnd} id={messages.youAreAboutToSubmitYourClaimAnd.id} />
      </P>
      <DuesProtectPermissions />
      <div className="row">
        <div className="form-group col-md-9 col-sm-9">
          <CheckboxInput
            name="signature"
            checked={signature === true}
            onChange={handleChange('form.signature')}
            disabled={isReadOnly}
            message={messages.agreeDuesProtect}
            messageId={messages.agreeDuesProtect.id}
          />
        </div>
      </div>
      <DuesProtectPrivacyStatements />
      <DuesProtectHipaaNotice />
    </ControlContainer>
  </Section>
);

DuesProtectSection.propTypes = {
  signature: PropTypes.bool.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(DuesProtectSection);



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepDeclaration/components/SubmitClaim/components/DuesProtectSection.js